module.exports = __webpack_public_path__ + "static/media/verse-Logo-2.b23bb5cb.png";